import { useMutation, useQuery } from '@tanstack/react-query';
import * as api from '@/api/translateBatch';
import type { StartTranslateBatchInput } from '@/types/translateJob';

export function useProviders() {
  return useQuery({
    queryKey: ['translate-providers'],
    queryFn: api.listProviders,
    staleTime: 60_000,
  });
}

export function useStartTranslate() {
  return useMutation({
    mutationFn: (input: StartTranslateBatchInput) => api.startBatch(input),
  });
}

export function useJobPoll(jobId: string | null) {
  return useQuery({
    queryKey: ['translate-job', jobId],
    queryFn: () => api.getJob(jobId!),
    enabled: !!jobId,
    refetchInterval: (q) => {
      const job = q.state.data;
      if (!job) return 1000;
      if (job.status === 'success' || job.status === 'failed') return false;
      return 1000;
    },
  });
}
